var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_vm._v(" ©"+_vm._s(_vm.Year)+" 版权所有 施耐德电气(中国)有限公司 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }